var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408,
    height: 270,
    viewBox: "0 0 408 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5167",
    "data-name": "Rectangle 5167",
    width: 408,
    height: 270,
    rx: 12,
    transform: "translate(84 232)",
    fill: "#2a61ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10622",
    "data-name": "Group 10622",
    transform: "translate(-84 -216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5155",
    "data-name": "Rectangle 5155",
    width: 408,
    height: 270,
    rx: 12,
    transform: "translate(84 216)",
    fill: "#2a61ad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_18",
    "data-name": "Mask Group 18",
    transform: "translate(0 -16)",
    opacity: 0.1,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 124.5,
    cy: 124.5,
    r: 124.5,
    transform: "translate(278 23)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.93f0e69be62a5b18d067c6ba14e983e2.svg";
export { ForwardRef as ReactComponent };